import { api } from "api/api";
import {
    BookAppointmentOnlineOptionItemModel
} from "models/BookAppointmentOnlineModel/BookAppointmentOnlineOptionItemModel";

export interface ItemDTO {
    id: string;
    name: string;
    price?: string;
    duration?: string;
    priceFrom?: string;
    priceTo?: string;
    durationFrom?: string;
    durationTo?: string;
}
export default async function getAppointmentTypeList(doctorId?: string): Promise<BookAppointmentOnlineOptionItemModel[]> {
    const url = 'api/public/book/appointment/online/appointment/type/list';

    const response = await api.get(url, {
            params: { doctorId }
        }
    );
    return response.data.data.map(
        (item: ItemDTO) => {
            return new BookAppointmentOnlineOptionItemModel(item);
        }
    )
};
